module.exports = __webpack_public_path__ + "img/item-8(1920).bf867a36.jpg";